<template>
  <div class="set_link">
    <el-dialog
      class="link_dialog self_dialog"
      :title="$t('view_dialog_index_111')"
      v-dialogDrag
      :visible.sync="dialogVisible"
      :modal-append-to-body="true"
      width="500px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @before-close="closeModule"
      :append-to-body="true"
      @close="close_dialog"
    >
      <div class="set_link_body c-custom_set_link_body" v-loading="loading">
        <my_radio
          titleWidth="auto"
          :option="$store.state.options.linkConfig"
          :selectValue.sync="listArr.linkType"
          :title="$t('view_dialog_index_112')"
          style="margin-bottom: 10px; margin-left: 0;"
          v-if="!$store.state.set_link.link_fun"
        ></my_radio>
        <!-- contact us  这个链接类型不显示 选了固定的 fun 功能选项 -->
        <p v-if="listArr.linkType == 'inside_link'">
          <my_select
            titleWidth="auto"
            width="250"
            :title="$t('view_dialog_index_113')"
            type="one_level"
            :options="$store.state.options.insideLink"
            :value.sync="listArr[listArr.linkType].type"
            :placeholder="$t('view_dialog_index_114')"
          ></my_select>
        </p>
        <!--站内链接-->
        <p v-if="listArr.linkType == 'inside_link' && listArr[listArr.linkType].type == 'section'">
          <my_search_select
            titleWidth="auto"
            width="250"
            :title="$t('view_dialog_index_115')"
            type="one_level"
            :options="$store.state.app.threeLevelNavList"
            :value.sync="listArr[listArr.linkType].section.value"
            :placeholder="$t('view_dialog_index_116')"
          ></my_search_select>
        </p>
        <p v-if="listArr.linkType == 'inside_link' && listArr[listArr.linkType].type == 'product'">
          <my_search_select
            titleWidth="auto"
            width="250"
            :title="$t('view_dialog_index_117')"
            type="one_level"
            :options="$store.state.app.proList"
            :value.sync="listArr[listArr.linkType].product.value"
            :placeholder="$t('view_dialog_index_118')"
          ></my_search_select>
        </p>
        <p v-if="listArr.linkType == 'inside_link' && listArr[listArr.linkType].type == 'article'">
          <my_search_select
            titleWidth="auto"
            width="250"
            :title="$t('view_dialog_index_119')"
            type="one_level"
            :options="$store.state.app.articleList"
            :value.sync="listArr[listArr.linkType].article.value"
            :placeholder="$t('view_dialog_index_120')"
          ></my_search_select>
        </p>
        <p v-if="listArr.linkType == 'inside_link' && listArr[listArr.linkType].type == 'case'">
          <my_search_select
            titleWidth="auto"
            width="250"
            :title="$t('view_dialog_index_121')"
            type="one_level"
            :options="$store.state.app.caseList"
            :value.sync="listArr[listArr.linkType].case.value"
            :placeholder="$t('view_dialog_index_122')"
          ></my_search_select>
        </p>
        <p v-if="listArr.linkType == 'inside_link' && listArr[listArr.linkType].type == 'help'">
          <my_search_select
            titleWidth="auto"
            width="250"
            :title="$t('view_dialog_index_123')"
            type="one_level"
            :options="$store.state.app.helpList"
            :value.sync="listArr[listArr.linkType].help.value"
            :placeholder="$t('view_dialog_index_124')"
          ></my_search_select>
        </p>
        <p
          v-if="listArr.linkType == 'inside_link' && listArr[listArr.linkType].type == 'product_type'"
        >
          <my_search_select
            titleWidth="auto"
            width="250"
            :title="$t('view_dialog_index_125')"
            type="one_level"
            :options="$store.state.app.proTypeList"
            :value.sync="listArr[listArr.linkType].product_type.value"
            :placeholder="$t('view_dialog_index_126')"
          ></my_search_select>
        </p>
        <p
          v-if="listArr.linkType == 'inside_link' && listArr[listArr.linkType].type == 'article_type'"
        >
          <my_search_select
            titleWidth="auto"
            width="250"
            :title="$t('view_dialog_index_127')"
            type="one_level"
            :options="$store.state.app.articleTypeList"
            :value.sync="listArr[listArr.linkType].article_type.value"
            :placeholder="$t('view_dialog_index_128')"
          ></my_search_select>
        </p>
        <p
          v-if="listArr.linkType == 'inside_link' && listArr[listArr.linkType].type == 'case_type'"
        >
          <my_search_select
            titleWidth="auto"
            width="250"
            :title="$t('view_dialog_index_129')"
            type="one_level"
            :options="$store.state.app.caseTypeList"
            :value.sync="listArr[listArr.linkType].case_type.value"
            :placeholder="$t('view_dialog_index_130')"
          ></my_search_select>
        </p>
        <p
          v-if="listArr.linkType == 'inside_link' && listArr[listArr.linkType].type == 'help_type'"
        >
          <my_search_select
            titleWidth="auto"
            width="250"
            :title="$t('view_dialog_index_131')"
            type="one_level"
            :options="$store.state.app.helpTypeList"
            :value.sync="listArr[listArr.linkType].help_type.value"
            :placeholder="$t('view_dialog_index_132')"
          ></my_search_select>
        </p>
        <!--站外链接-->
        <p v-if="listArr.linkType == 'outside_link'">
          <my_input
            @change="
              val => {
                if (val.indexOf('https://') < 0 && val.indexOf('http://') < 0 && val.trim() !== '') {
                  listArr[listArr.linkType].url = 'http://' + val;
                }
              }
            "
            style="margin: 0"
            titleWidth="auto"
            width="250"
            :title="$t('view_dialog_index_133')"
            placeholder="http://"
            :value.sync="listArr[listArr.linkType].url"
            type="one_level"
          ></my_input>
        </p>        
        <my_checkbox
          titleWidth="auto"
          style="margin: 0"
          class="custom_my_checkbox_layer"
          v-if="listArr.linkType == 'outside_link'"
          :checkList.sync="listArr.isOpen"
          :option="$store.state.options.newPageNofollow"
        ></my_checkbox>
        <my_checkbox
          titleWidth="auto"
          style="margin: 0"
          v-if="listArr.linkType == 'inside_link'"
          :checkList.sync="listArr.isOpen"
          :option="$store.state.options.newPageOpen"
        ></my_checkbox>
        <!--功能-->
        <p v-if="listArr.linkType == 'fun'">
          <my_select
            titleWidth="auto"
            width="250"
            :title="$t('view_dialog_index_134')"
            type="one_level"
            :options="$store.state.options.functionList"
            :value.sync="listArr[listArr.linkType].type"
            :placeholder="$t('view_dialog_index_135')"
          ></my_select>
        </p>
        <p
          v-if="listArr.linkType == 'fun' && listArr[listArr.linkType].type === 'submit_form'"
          class="set_one_level"
          style="margin-bottom: 0; overflow: hidden;"
        >
          <my_select
            titleWidth="auto"
            width="250"
            class="custom_my_select"
            :title="$t('view_dialog_index_136')"
            type="one_level"
            :options="$store.state.app.formList"
            :value.sync="listArr[listArr.linkType].submit_form.value"
            :placeholder="$t('view_dialog_index_137')"
          ></my_select>
          <el-button titleWidth="95" size="small" class="module my_button" @click="addForm">{{$t('view_dialog_index_138')}}</el-button>
        </p>
        <p
          v-if="listArr.linkType == 'fun' && listArr[listArr.linkType].type === 'customer_service'"
          class="set_one_level"
        >
          <my_select
            titleWidth="106"
            width="250"
            :title="$t('view_dialog_index_139')"
            type="one_level"
            :options="$store.state.options.customerServiceList"
            :value.sync="listArr[listArr.linkType].customer_service.value"
            :placeholder="$t('view_dialog_index_116')"
          ></my_select>
          <el-button titleWidth="95" size="small" class="module my_button">{{$t('view_dialog_index_140')}}</el-button>
        </p>
        <p
          class="set_one_level"
          v-if="listArr.linkType == 'fun' && listArr[listArr.linkType].type === 'submit_form'"
        >
          <span class="title" style="width: auto">{{$t('view_dialog_index_141')}}</span>
          <!-- :href="$store.state.app.manageFormURL"   外贸站的 表单路由变了  $store.getters['app/is_road_type'] -->
          <a
            class="module text_button"
            target="_blank"
            :href="$store.getters['app/form_list_link']"
          >{{$t('view_dialog_index_142')}}</a>
          <!-- form_list_link -->
          <!--<el-button type="text" class="module text_button" size="small" @click="manageForm">点击管理表单</el-button>-->
        </p>
        <p
          v-if="listArr.linkType == 'fun' && listArr[listArr.linkType].type === 'telephone_advisory'"
        >
          <my_input
            titleWidth="auto"
            width="250"
            style="margin: 0"
            :title="$t('view_dialog_index_143')"
            :placeholder="$t('view_dialog_index_144')"
            :value.sync="listArr[listArr.linkType].telephone_advisory.value"
            type="one_level"
          ></my_input>
        </p>
        <p
          v-if="listArr.linkType == 'fun' && listArr[listArr.linkType].type === 'information_advisory'"
        >
          <my_input
            titleWidth="auto"
            width="250"
            style="margin: 0"
            :title="$t('view_dialog_index_145')"
            :placeholder="$t('view_dialog_index_146')"
            :value.sync="listArr[listArr.linkType].information_advisory.value"
            type="one_level"
          ></my_input>
        </p>
        <p
          class="phone_note"
          v-if="listArr.linkType == 'fun' && (listArr[listArr.linkType].type === 'telephone_advisory' || listArr[listArr.linkType].type === 'information_advisory')"
        >{{$t('view_dialog_index_172')}}{{listArr[listArr.linkType].type ==='telephone_advisory' ? $t('view_dialog_index_148') : $t('view_dialog_index_149')}}</p>
        <p v-if="listArr.linkType == 'fun' && listArr[listArr.linkType].type === 'file_download'">
          <my_img_button
            titleWidth="auto"
            :title="$t('view_dialog_index_150')"
            :buttonTitle="listArr[listArr.linkType].file_download.url == '' ? $t('view_dialog_index_151') : $t('view_dialog_index_152')"
            :buttonType="2"
            :fileName.sync="listArr[listArr.linkType].file_download.name"
            iconIsShow="left"
            type="one_level"
            :tips="$t('view_back_top_edit_98')"
            @uploadImg="uploadImg"
            :imgUrl.sync="listArr[listArr.linkType].file_download.url"
          ></my_img_button>
        </p>

        <!-- 用户发邮件给我 -->
        <template v-if="listArr.linkType == 'fun' && listArr[listArr.linkType].type === 'send_email'">
          <my_input
          titleWidth="auto"
          style="margin: 0;"
          width="250"
          :title="$t('view_dialog_index_153')"
          :placeholder="$t('view_dialog_index_154')"
          :value.sync="listArr[listArr.linkType].send_email.recipient"
          inputType="email"
          type="one_level"
          :required-status="true"
        ></my_input>
        <!-- var reg = /^[0-9A-Za-z][-_.0-9A-Za-z]*@[0-9A-Za-z_-]+(\.[0-9A-Za-z]+)+$/ -->
        <my_input
          titleWidth="auto"
          style="margin: 0;"
          width="250"
          :title="$t('view_dialog_index_155')"
          :placeholder="$t('view_dialog_index_156')"
          :value.sync="listArr[listArr.linkType].send_email.subject"
          type="one_level"
          :maxlength="60"
          :show-word-limit="true"
          class="input-padding-set"
        ></my_input>
        <my_textarea
          titleWidth="auto"
          width="250"
          style="margin: 0;"
          :title="$t('view_dialog_index_157')"
          :placeholder="$t('view_dialog_index_158')"
          :textValue.sync="listArr[listArr.linkType].send_email.content"
          type="one_level"
          :maxlength="100"
          :show-word-limit="true"
          class="input-padding-set"
          :enter-disabed="true"
        ></my_textarea>
        <p class="phone_note email_color"><!-- 备注： -->{{$t('view_dialog_index_159')}}，{{$t('view_dialog_index_160')}}</p>
        <!-- <my_font_size title="描述" titleWidth="96" hiddenIsShow="false"></my_font_size> -->
        </template>
        <p v-if="listArr[listArr.linkType].type == 'jump_section'">
          <my_radio
            titleWidth="auto"
            style="margin-left: 0"
            :option="jumpType_options"
            :selectValue.sync="listArr[listArr.linkType].jump_section.type"
            :title="$t('view_dialog_index_161')"
          ></my_radio>
          <!-- $store.state.options.jumpType -->
        </p>
        <p
          v-if="listArr[listArr.linkType].type == 'jump_section' && listArr[listArr.linkType].jump_section.type == 'cur_page'"
        >
          <my_select
            titleWidth="auto"
            width="250"
            :title="$t('view_dialog_index_162')"
            type="one_level"
            :options="anchorList"
            :value.sync="listArr[listArr.linkType].jump_section.cur_page_value"
            :placeholder="$t('view_dialog_index_116')"
          ></my_select>
        </p>
        <p
          v-if="listArr[listArr.linkType].type == 'jump_section' && listArr[listArr.linkType].jump_section.type == 'other_page'"
        >
          <my_search_select
            titleWidth="auto"
            width="250"
            :title="$t('view_dialog_index_115')"
            type="one_level"
            :options="$store.state.app.websiteSection"
            :value.sync="listArr[listArr.linkType].jump_section.site_section"
            :placeholder="$t('view_dialog_index_116')"
          ></my_search_select>
        </p>
        <p
          v-if="listArr[listArr.linkType].type == 'jump_section' && listArr[listArr.linkType].jump_section.type == 'other_page'"
        >
          <my_select
            titleWidth="auto"
            width="250"
            :title="$t('view_dialog_index_162')"
            type="one_level"
            :options="anchorList"
            :value.sync="listArr[listArr.linkType].jump_section.other_page_value"
            :placeholder="$t('view_dialog_index_116')"
          ></my_select>
        </p>
        <p v-if="listArr[listArr.linkType].type == 'pop_video'">
          <my_radio
            titleWidth="auto"
            style="margin-left: 0"
            :option="$store.state.options.fileType"
            :selectValue.sync="listArr[listArr.linkType].pop_video.type"
            :title="$t('view_dialog_index_161')"
          ></my_radio>
        </p>
        <div
          v-if="listArr[listArr.linkType].type == 'pop_video' && listArr[listArr.linkType].pop_video.type == 'local_add'"
        >
          <my_img_button
            titleWidth="auto"
            :buttonTitle="listArr[listArr.linkType].pop_video.local_add.url == '' ? $t('view_dialog_index_163') : $t('view_dialog_index_164')"
            type="one_level"
            @uploadImg="uploadVideo"
            :buttonType="2"
            class="custom_my_img_button"
            :fileName.sync="listArr[listArr.linkType].pop_video.local_add.name"
            :imgUrl.sync="listArr[listArr.linkType].pop_video.local_add.url"
          ></my_img_button>
        </div>
        <div
          v-if="listArr[listArr.linkType].type == 'pop_video' && listArr[listArr.linkType].pop_video.type == 'common_code'"
        >
          <my_input
            titleWidth="auto"
            width="300"
            style="margin: 0"
            :rows="4"
            class="custom_my_input"
            inputType="textarea"
            :placeholder="$t('view_dialog_index_165')"
            :value.sync="listArr[listArr.linkType].pop_video.common_code.url"
            type="one_level"
          ></my_input>
        </div>
        <div
          v-if="listArr[listArr.linkType].type == 'pop_video' && listArr[listArr.linkType].pop_video.type == 'video_address'"
        >
          <my_input
            titleWidth="auto"
            width="300"
            :rows="4"
            style="margin: 0"
            class="custom_my_input"
            inputType="textarea"
            :placeholder="$t('view_dialog_index_166')"
            :value.sync="listArr[listArr.linkType].pop_video.video_address.url"
            type="one_level"
          ></my_input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="confirmButton" :disabled="!is_change">{{$t('view_public_topbar_24')}}</el-button>
        <el-button @click="closeModule" size="small">{{$t('view_public_topbar_11')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import i18n from '../../language/index'

import { get_anchor, getMailConfig } from "@/api/app";
export default {
  name: "global",
  data() {
    return {
      dialogVisible: true,
      loading: true,
      listArr: JSON.parse(JSON.stringify(this.$store.state.set_link.link_edit)),
      is_change: false,
      email: ''
    };
  },
  computed: {
    // listArr () {
    //   //return this.$store.state.set_link.link_edit;
    //   const link_edit = JSON.parse(JSON.stringify(this.$store.state.set_link.link_edit));
    //   console.log(link_edit)
    //   return link_edit;
    // },
    anchorList() {
      let anchorList = []
      if(this.$store.state.anchor.anchorList.thisPage) {
          anchorList = this.$store.state.anchor.anchorList.thisPage
      }
      if(this.$store.state.anchor.anchorList.common) {
        anchorList = anchorList.concat(this.$store.state.anchor.anchorList.common)
      }
      let anchorData = this.listArr.fun.jump_section;
      let tag_cur_page = false;
      let tag_other_page = false;
      // anchorList.map(e => {
      //   if (e.id === anchorData.cur_page_value) {
      //     tag_cur_page = true;
      //   }
      //   if (e.id === anchorData.other_page_value) {
      //     tag_other_page = true;
      //   }
      // });
      // if (!tag_cur_page) {
      //   anchorData.cur_page_value = "";
      // }
      // if (!tag_other_page) {
      //   anchorData.other_page_value = "";
      // }
      return anchorList.map(e => {
        let item = {
          label: e.anchorName,
          value: e.id
        };
        return item;
      });
    },
    contact_us_link() {
      return this.$store.state.set_link.contact_us_link
    },
    jumpType_options() {
      return this.contact_us_link ? this.$store.state.options.jumpType.slice(1):this.$store.state.options.jumpType
    }
  },
  watch: {
    "listArr.fun.jump_section.type"(val) {
      if (val === "cur_page") {
        let pageName = this.$store.state.app.now_page;
        this.templet.get_anchor(pageName);
      } else if (
        val === "other_page" &&
        this.listArr.fun.jump_section.site_section.routerPath
      ) {
        let pageName = this.listArr.fun.jump_section.site_section.routerPath.split('?')[0]
        this.templet.get_anchor(pageName);
      }
    },
    "listArr.fun.jump_section.site_section"(val) {
      this.listArr.fun.jump_section.other_page_value = "";
      let pageName = val.routerPath
      if(this.listArr.fun.jump_section.type=='other_page') pageName=pageName.split('?')[0]
      this.templet.get_anchor(pageName);
    },
    "listArr.fun.send_email": {
      handler: function(val, oldVal) {
        this.is_change = true;
      },
      deep: true
    },
    "listArr.fun.send_email.content"(val) {
      this.listArr.fun.send_email.content=val.replace(/\&/g,"")
    },
    listArr: {
      handler: function(val, oldVal) {
        this.is_change = true;
      },
      deep: true
    }
  },
  methods: {
    async getMailConfig() {
      let res = await getMailConfig()
      if(Object.prototype.toString.call(res.data) === '[object Object]' && res.data.sendMailFrom){
        this.email = res.data.sendMailFrom
      }
    },
    getSelectValPreview(val) {
      let tipsObj = this.$store.state.options.tipsObj;
      if (val.linkType == "none") {
        val.select_val_preview = "";
      } else if (val.linkType == "inside_link") {
        let type = val.inside_link.type;
        if (typeof val.inside_link[type].value.name == "undefined") {
          this.$message.warning(tipsObj[type]);
          return false;
        } else {
          val.select_val_preview = val.inside_link[type].value.name;
        }
      } else if (val.linkType == "fun") {
        let type = val.fun.type;
        if (type == "submit_form") {
          let formName = this.getName(
            val.fun.submit_form.value,
            this.$store.state.app.formList
          );
          if (formName == "") {
            this.$message.warning(tipsObj[type]);
            return false;
          } else {
            val.select_val_preview = formName;
          }
        } else if (type == "customer_service") {
          let customerName = this.getName(
            val.fun[type].value,
            this.$store.state.options.customerServiceList
          );
          if (customerName == "") {
            this.$message.warning(tipsObj[type]);
            return false;
          } else {
            val.select_val_preview = customerName;
          }
        } else if (type == "telephone_advisory") {
          if (val.fun[type].value == "") {
            this.$message.warning(tipsObj[type]);
            return false;
          } else {
            val.select_val_preview = i18n.t('view_dialog_index_167');
          }
        } else if (type == "information_advisory") {
          if (val.fun[type].value == "") {
            this.$message.warning(tipsObj[type]);
            return false;
          } else {
            val.select_val_preview = i18n.t('view_dialog_index_149');
          }
        } else if (type == "file_download") {
          if (val.fun[type].name == "") {
            this.$message.warning(tipsObj[type]);
            return false;
          } else {
            val.select_val_preview = val.fun[type].name;
          }
        } else if (type == "jump_section") {
          if (val.fun.jump_section.type == "cur_page") {
            if (val.fun.jump_section.cur_page_value == "") {
              this.$message.warning(tipsObj.jump_section);
              return false;
            } else {
              val.select_val_preview = this.getName(
                val.fun.jump_section.cur_page_value,
                this.anchorList
              );
            }
          } else {
            if (val.fun.jump_section.other_page_value == "") {
              this.$message.warning(tipsObj.jump_section);
              return false;
            } else {
              val.select_val_preview = this.getName(
                val.fun.jump_section.other_page_value,
                this.anchorList
              );
            }
          }
        } else if (type == "pop_video") {
          let type = val.fun.pop_video.type;
          if (val.fun.pop_video[type].url == "") {
            this.$message.warning(tipsObj[type]);
            return false;
          } else {
            val.select_val_preview = i18n.t('view_dialog_index_168');
          }
        } else if(type == 'send_email') { // 用户发邮件给我 邮箱必填
          let reg = /^[0-9A-Za-z][-_.0-9A-Za-z]*@[0-9A-Za-z_-]+(\.[0-9A-Za-z]+)+$/
          // console.log(val.fun.send_email, 55, reg.test(val.fun.send_email.recipient))
          if(val.fun.send_email.recipient== ''  || !reg.test(val.fun.send_email.recipient)) {
            this.$message.warning(tipsObj[type]);
            return false;
          } else {
            val.select_val_preview = i18n.t('view_dialog_index_169');
          }
        }
      } else if (val.linkType == "outside_link") {
        if (val.outside_link.url === "") {
          this.$message.warning(tipsObj.outside_link);
          return false;
        } else {
          val.select_val_preview = val.outside_link.url;
        }
      }
      return true;
    },
    uploadImg() {
      this.$store.commit("image_upload/set_showTag", true);
      this.$store.commit("image_upload/set_fileType", this.$store.state.image_upload.TYPE_MY_FILE);
      this.$store.commit("image_upload/set_fileLimit", 1);
      this.$store.commit("image_upload/set_isDownload", true)
      this.$store.state.image_upload.imgFile = e => {
        if (e && e instanceof Array && e.length > 0) {
          this.listArr[this.listArr.linkType].file_download.url = e[0].filePath;
          this.listArr[this.listArr.linkType].file_download.name = e[0].name;
        }
        this.$store.state.image_upload.imgFile = null;
      };
    },
    uploadVideo() {
      this.$store.commit("image_upload/set_showTag", true);
      this.$store.commit("image_upload/set_fileType", this.$store.state.image_upload.TYPE_VIDEO);
      this.$store.commit("image_upload/set_fileLimit", 1);
      this.$store.state.image_upload.imgFile = e => {
        if (e && e instanceof Array && e.length > 0) {
          this.listArr[this.listArr.linkType].pop_video.local_add.url =
            e[0].filePath;
          this.listArr[this.listArr.linkType].pop_video.local_add.name =
            e[0].name;
        }

        this.$store.state.image_upload.imgFile = null;
      };
    },
    confirmButton() {
      let result = this.getSelectValPreview(this.listArr);
      if (result) {
        this.dialogVisible = false;
        //数据复写回去
        console.log(this.listArr)
        this.$store.commit(
          "set_link/set_link_edit",
          Object.assign(this.$store.state.set_link.link_edit, this.listArr)
        );
      }
    },

    close_dialog() {
      this.dialogVisible = true;
      this.$store.commit("set_link/set_link_dialog_show", false);
    },

    closeModule() {
      if (this.is_change) {
        this.$confirm(i18n.t('view_dialog_index_170'), i18n.t('view_public_topbar_23'), {
          confirmButtonText: i18n.t('view_public_topbar_24'),
          cancelButtonText: i18n.t('view_public_topbar_11'),
          center: true,
          // customClass: "del_dialog",
          appendToBody: true
        })
          .then(() => {
            this.close_dialog();
          })
          .catch(() => {});
      } else {
        this.close_dialog();
      }
    },
    addForm() {
      if (this.$store.state.app.formList.length >= 20) {
        this.$message.error(i18n.t('view_dialog_index_171'));
        return false;
      }
      // 打开表单弹框
      this.$store.commit("add_form/set_add_form_show", true);
      // 修改表单操作类型 add 新增 edit 编辑
      this.$store.commit("add_form/set_form_type", "add");
      // 设置当前编辑表单的对象
      this.$store.commit(
        "add_form/set_edit_form",
        JSON.parse(JSON.stringify(this.$store.state.add_form.default_form))
      );
    },
    getName(id, data) {
      let name = "";
      if (id !== "") {
        for (let i = 0; i < data.length; i++) {
          if (data[i].value === id) {
            name = data[i].label;
            break;
          }
        }
      }
      return name;
    },
    checkAnchor() {
      let anchorData = this.listArr.fun.jump_section;
      let tag_cur_page = false;
      let tag_other_page = false;
      this.anchorList.map(e => {
        if (e.id === anchorData.cur_page_value) {
          tag_cur_page = true;
        }
        if (e.id === anchorData.other_page_value) {
          tag_other_page = true;
        }
      });
      if (!tag_cur_page) {
        anchorData.cur_page_value = "";
      }
      if (!tag_other_page) {
        anchorData.other_page_value = "";
      }
    }
  },
  async mounted() {
    if(this.listArr.fun.jump_section.type === "cur_page" && this.contact_us_link) {
      this.listArr.fun.jump_section.type = 'other_page' // contact us 处理老数据
    }
    if (this.listArr.fun.jump_section.type === "cur_page") {
      let pageName = this.$store.state.app.now_page;
      this.templet.get_anchor(pageName);
    } else if (
      this.listArr.fun.jump_section.type === "other_page" &&
      this.listArr.fun.jump_section.site_section.routerPath
    ) {
      let pageName = this.listArr.fun.jump_section.site_section.routerPath.split('?')[0]
      this.templet.get_anchor(pageName);
    }
    if (this.$store.state.set_link.link_dialog_show) {
      this.loading = false;
    }
    // 过滤选择表单的历史脏数据
    this.templet.getFormList().then(() => {
      let isSelectForm = false;
      this.$store.state.app.formList.map(item => {
        if (item.value === this.listArr["fun"].submit_form.value) {
          isSelectForm = true;
        }
      });
      this.listArr["fun"].submit_form.value = isSelectForm
        ? this.listArr["fun"].submit_form.value
        : "";
    });
    // 这边 要处理 listArr没有 send_email的类型
    if(!this.listArr["fun"].send_email) {
      this.$set(this.listArr["fun"], 'send_email', {
        recipient: '', // 收件人
        subject: '', // 邮件主题
        content: '' // 邮件正文
      })
    }
    // 获取后台邮箱地址
    await this.getMailConfig()
    if(!this.listArr.fun.send_email.recipient) {
      this.listArr.fun.send_email.recipient = this.email
    }
  }
};
</script>

<style lang="scss" scoped>
.self_dialog {
  /deep/ .el-dialog {
    box-shadow: 0 0 8px 1px rgba(0, 0, 0, 0.14);
    .el-dialog__body {
      padding: 26px 20px;
      display: flex;
      justify-content: center;
      .text_button {
        font-size: 13px;
        cursor: pointer;
        color: #008eff;
      }
      .set_link_body{
        .el-textarea {
           // background: red;
           width:250px;
          .el-textarea__inner {
            width: 250px;
            // background: red;
          }
        }
        .input-padding-set{
          .el-input__suffix, .el-input__count{
            // right: -50px;
          }
        }

        &.c-custom_set_link_body {
          .my_img_button_layer {
            .tips_left {
              position: static;
              margin-right: 8px;
            }
            &.custom_my_img_button {
              .tips_left {
                margin: 0;
              }
              .el-button,.module {
                margin-left: 0;
              }
            }
          }
          .my_checkbox_layer {
            margin-left: 0;
            .el-checkbox-group {
              margin: 0 !important;
            }
          }

          .custom_my_input {
            .module,.el-textarea {
              margin-left: 0;
            }
          }

          .custom_my_select {
            .title {
              flex-shrink: 0;
            }
          }

          .custom_my_checkbox_layer {
            .set_two_level {
              line-height: 1;
            }
          }
        }
      }

    }
    .el-dialog__footer {
      .dialog-footer {
        display: flex;
        flex-direction: row;
        justify-content: center;
        padding: 18px;
        .el-button {
          margin: 0 18px;
          padding: 0 28px;
          height: 34px;
          font-size: 14px;
        }
      }
    }
  }
}
.module {
  cursor: pointer;
}
.phone_note {
  margin-top: 8px;
  // margin-left: 68px;
  margin-left: 0;
  font-size: 13px;
  color: rgb(102, 102, 102);
  &.email_color{
    color: #ADADAD
  }
}
</style>



// WEBPACK FOOTER //
// src/view/dialog/index.vue